import { render } from "./ChatsEntrantesContent.vue?vue&type=template&id=72cae737&ts=true"
import script from "./ChatsEntrantesContent.vue?vue&type=script&lang=ts"
export * from "./ChatsEntrantesContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__